import clone from 'clone';

/**
 * mutates the permissions.rna property with the data given, as-is
 */
export const getMyPermissionsForRescueNetApplicant = (state, data) => {
  state.permissions.rna = clone(data);
};
